export default __webpack_public_path__ + "static/media/button-plus.1b282b95.svg";